var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-left-menu-toggler"}},[_c('span',{staticClass:"glyphicon",class:_vm.iconClass,on:{"click":_vm.onIconClicked}})])}
var staticRenderFns = []

export { render, staticRenderFns }